import { NavLink, SidebarNavLink, MenuNavLink } from '../components/linktypes';
import { FireIcon, TvIcon, LayerIcon, StatsIcon } from 'icons';

export const mainNavList = (user = false) => {
  const hasUserId = user && user.dumpertId;
  const navList = [
    {
      label: 'Nieuw',
      ElementType: NavLink,
      pathname: '/',
      IconType: LayerIcon,
    },
    {
      label: 'Toppers',
      ElementType: NavLink,
      pathname: '/toppers',
      IconType: FireIcon,
    },
    {
      label: 'DumpertTV',
      ElementType: NavLink,
      pathname: '/dumperttv',
      IconType: TvIcon,
    },
    {
      label: 'Statistieken',
      ElementType: NavLink,
      pathname: !hasUserId ? '/inloggen?next=/statistieken' : '/statistieken',
      IconType: StatsIcon,
    },
  ];

  return navList;
};

export const featuresNavList = (user) => {
  const hasUserId = user && user.dumpertId;
  return [
    hasUserId
      ? {
          label: 'Mijn afspeellijsten',
          ElementType: SidebarNavLink,
          pathname: `/reaguurder/afspeellijsten/${user.dumpertId}`,
        }
      : {},
    { label: 'Mijn badges', ElementType: SidebarNavLink, pathname: '/reaguurder/badges' },
  ];
};

export const userNavList = (user) => [
  {
    label: 'Reaguurder',
    ElementType: MenuNavLink,
    pathname: '/reaguurder',
  },
  {
    label: 'Reaguurderinstellingen',
    ElementType: MenuNavLink,
    pathname: '/reaguurder/instellingen',
  },
  {
    label: 'Mijn profiel',
    ElementType: MenuNavLink,
    pathname: `/profiel/${user?.name}`,
  },
];
